import { GlobalStyles, createTheme } from "@mui/material";
import ContentContainer from "@common/ContentContainer/ContentContainer";
import TopAndTabBarContainer from "@common/TopAndTabBarContainer";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1440,
    },
  },
  // These are default MUI zIndex values
  zIndex: {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
  spacing: 4,
});

export const globalStyles = (
  <GlobalStyles
    styles={(theme) => ({
      body: {
        paddingTop: 112,
        [theme.breakpoints.up("md")]: {
          paddingTop: 120,
        },
        "&.hamburger-menu-open": {
          [`${ContentContainer}, ${TopAndTabBarContainer}`]: {
            transform: "translateX(320px)",

            [theme.breakpoints.up("md")]: {
              transform: "translateX(400px)",
            },
          },
        },
      },
    })}
  />
);

export default theme;
